import React from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { throttle } from 'lodash';

import { AirtableDataConsumer } from '../../core/AirtableDataProvider';
import ParameterMap from '../../core/ParameterMap';
import AirtableImage from '../../core/AirtableImage';

import SocialButtonList from '../SocialButtonList';

import './Header.scss';
import PageNav from './PageNav';
import PageNavMobile from './PageNavMobile';

const COLLAPSE_AFTER = 50;
const THROTTLE_TIME = 150;

interface Props { }

export default class Header extends React.Component<Props>
{
  state = {
    collapsed: false,
    expandMobileNav: false,
  }

  render()
  {
    return (
      <AirtableDataConsumer>
        { data => data && this._render(data.generalParameters) }
      </AirtableDataConsumer>
    );
  }

  componentDidMount()
  {
    window.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount()
  {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll = throttle(() => {
    const el = window.document.documentElement;
    if (!el) {
      return;
    }
    const scroll = el.scrollTop;
    this.setState({
      collapsed: scroll > COLLAPSE_AFTER,
//      expandMobileNav: false,
    });
  }, THROTTLE_TIME);

  menuClick = () =>
  {
    this.setState({ expandMobileNav: !this.state.expandMobileNav });
  }

  _render(general: ParameterMap)
  {
    const phone = general.getValue('Phone');
    const email = general.getValue('Email');
    const logo = general.getImage('Logo');

    let logoMaxHeight = '';

    try {
      logoMaxHeight = general.getValue('LogoMaxHeight');
    } catch (e) {
      console.warn(e)
    }


    let headerBottomPadding = '1 rem';
    try {
      headerBottomPadding = general.getValue('HeaderBottomPadding');
    } catch (e) {
      console.warn(e)
    }


    const { collapsed } = this.state;

    const headerClassName =
      `page-header f6 bg-white w-100 ${ collapsed ? 'collapsed' : '' }`;

    return (
      <>
        <header className={ headerClassName }>

          <div className="theme--top-bar page-header-topbar flex justify-center white bg-silver ph3 pv3 h2-5">
            <div className="flex flex-row flex-auto wfull items-center">
              <div className="flex-auto sep-pipe">
                <span>{ phone }</span>
                <span className="dn di-ns"><a
                  target="_blank" rel="noopener noreferrer"
                  className="link white dim" href={ `mailto:${ email }` }>{ email }</a></span>
              </div>
              <div>
                <SocialButtonList />
              </div>
            </div>
          </div>

          <div style={{paddingBottom: headerBottomPadding}} className="flex justify-center pv3 ph3 theme--page-nav">
            <div className="flex flex-row flex-auto wfull">
              <div className="flex-auto">
                <Link to="/">
                  <AirtableImage image={ logo } render={ url =>
                    <img style={{ maxHeight: logoMaxHeight }} alt="logo" src={ url } />
                  } />
                </Link>
              </div>
              <div className="dn db-l">
                <PageNav />
              </div>
              <div onClick={ this.menuClick } className="dn-l f3 pt1 pr1 link dim">
                <FontAwesomeIcon icon={ faBars } />
              </div>
            </div>
          </div>
          <div className={ this.state.expandMobileNav ? '' : 'dn' }>
            <PageNavMobile />
          </div>
        </header>
        <div style={{ height: '7rem' }}></div>
      </>
    );
  }
}
